/**
 * Normalizes raw hex input pasted/typed by creators so it can be safely stored.
 * Removes any leading `#`, trims whitespace, and uppercases for consistency.
 */
export const sanitizeHexColorInput = (
  input: string | null | undefined,
): string => {
  if (typeof input !== 'string') {
    return '';
  }

  return input.replace(/#/g, '').trim().toUpperCase();
};
